// Generated file - do not change manually!

/**
 * Different types of Bar.
 */
export enum BarDesign {
  /**
   * Floating Footer type - there is visible border on all sides
   */
  FloatingFooter = 'FloatingFooter',

  /**
   * Footer type
   */
  Footer = 'Footer',

  /**
   * Default type
   */
  Header = 'Header',

  /**
   * Subheader type
   */
  Subheader = 'Subheader'
}
